import styled from "styled-components";

export const SearchFieldWrapper = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`;

export const SearchFieldLabel = styled.label`
  display: block;
  margin-bottom: 0.5rem;
`;

export const SearchInputContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  min-width: 0;

  & > * {
    flex: 1;
    min-width: 0;
  }

  input {
    width: 100%;
    min-width: 0;
    padding-right: 2.5rem;
    box-sizing: border-box;
  }

  .search-icon-wrapper {
    position: absolute;
    top: 50%;
    right: 0.75rem;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

  .search-icon-wrapper img {
    width: 20px;
    height: 20px;
    opacity: 0.6;
  }
`;

export const SearchFieldsRow = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 1rem;

  & > * {
    flex: 1;
    min-width: 220px;
  }
`;

export const UserSearchContainer = styled.div`
  position: relative;
  width: 100%;
  min-width: 0;
`;

export const SelectedUserChip = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
  height: 42px;
  min-width: 0;
  box-sizing: border-box;
  padding: 0 0.4rem 0 0.75rem;
  border-radius: 6px;
  border: 2px solid #bebebe;

  button:first-child {
    flex: 1;
    min-width: 0;
    justify-content: flex-start !important;
    cursor: default;
  }
`;

export const SearchColumnWrapper = styled.div`
  position: relative;
  width: 100%;
  min-width: 0;
`;

export const TableContentWrapper = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow: auto;
`;
